import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.classList.remove("d-none");
  }

  formValidate(e) {
    let errors = false;
    e.target.querySelectorAll("input.vin").forEach((input) => {
      if (input.classList.contains("is-invalid")) {
        errors = true;
      }
    });

    if (errors) {
      e.preventDefault();
      setTimeout(() => {
        const submitBtn = document.querySelector(".form-submit");
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.innerHTML = submitBtn.dataset.originalMsg || submitBtn.innerHTML;
        }
      }, 100);
      return false;
    }
    return true;
  }

  validateVin(e) {
    const input = e.target;
    const value = input.value.toUpperCase().trim();
    input.value = value;
    if (this.validate(value)) {
      input.classList.remove("is-invalid");
    } else {
      input.classList.add("is-invalid");
    }
  }

  validate(vin) {
    if (vin[0] == "z" || vin[0] == "Z") return true;
    if (vin.length !== 17) return false;
    return this.get_check_digit(vin) === vin[8];
  }

  transliterate(c) {
    return "0123456789.ABCDEFGH..JKLMN.P.R..STUVWXYZ".indexOf(c) % 10;
  }

  get_check_digit(vin) {
    var map = "0123456789X";
    var weights = "8765432X098765432";
    var sum = 0;
    for (var i = 0; i < 17; ++i)
      sum += this.transliterate(vin[i]) * map.indexOf(weights[i]);
    return map[sum % 11];
  }
}
